import Radio from 'backbone.radio';
import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-change-account-details.hbs';


var ChangeAccountDetailView = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        load_spinner: '.loader',
        form: 'form',
        submit: '.submit',
        given_name: '.given-name',
        family_name: '.family-name',
        organization: '.organization',
        country: '.country'
    },
    events: {
        'submit @ui.form': 'on_submit',
        'keyup @ui.given_name': 'validate',
        'paste @ui.given_name': 'validate',
        'change @ui.given_name': 'validate',
        'keyup @ui.family_name': 'validate',
        'paste @ui.family_name': 'validate',
        'change @ui.family_name': 'validate',
        'keyup @ui.organization': 'validate',
        'paste @ui.organization': 'validate',
        'change @ui.organization': 'validate',
        'keyup @ui.country': 'validate',
        'change @ui.country': 'validate',
    },
    initialize: function () {
        this.destroyOnClose();
        this.focusFirstInput();
        _.bindAll(this, 'on_success', 'error');
    },
    onRender: function () {
        this.validate();
    },
    validate: function() {
        var validation_ui = ['given_name', 'family_name', 'organization', 'country'];
        let score = 0;
        validation_ui.forEach(k => { 
            if (this.ui[k].val() && this.ui[k].val() !== "") {
                score+=1;
            } else if (this.ui[k].val() === this.model.get(k)) {
                score+=1;
            }
        });
        if (score === 4) {
            this.ui.submit.prop('disabled', false);
            return true;
        } else {
            this.ui.submit.prop('disabled', true);
            return false;
        }
    },

    on_submit: function (e) {
        e.preventDefault();
        
        this.model.change_account_details({given_name: this.ui.given_name.val(), family_name:this.ui.family_name.val(), organization:this.ui.organization.val(), country:this.ui.country.val()})
        .done(this.on_success)
        .fail(this.error);
    },

    on_success: function () {
        Radio.request('alerts', 'showAlert', {
            message: `Successfully updated ${this.model.get('username')}`,
            messageType: 'success'
        });
        this.closeDialog();
    },
    error: function (error) {
        var err_string = error.responseJSON.errors[0].detail;
        DialogInterface.showAlert.call(this, 'alert-danger', err_string);
    },
});
export default ChangeAccountDetailView;

